import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InternalUser = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/');
    }, []);

    return (
        <>
            <div>Redirecting...</div>
        </>
    );
};

export default InternalUser;
